import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Row, Col } from "antd";
import "./SignIn.page.scss";
import { initAuthenticationPending } from "store/Slices/authSlice";
import { toast } from "react-toastify";
import { useState } from "react";

const initialValues = {
  username: "",
  password: "",
};

const SignUpSchema = Yup.object().shape({
  username: Yup.string()
    .required("Email Address is required.")
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      "Invalid email address"
    ),
  password: Yup.string()
    .required("password is required.")
    .min(6, "Password must be atleast 6 characters"),
});

const fields = [
  {
    name: "username",
    label: "Email Address",
    placeholder: "Enter your email",
  },
  { name: "password", label: "Password", placeholder: "Enter your password" },
];

function SignIn() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const login = (email, password) => {
    return async () => {
      setLoading(true);

      initialValues.username = email;
      initialValues.password = password;
      const formBody = Object.keys(initialValues)
        .map(
          (key) =>
            encodeURIComponent(key) +
            "=" +
            encodeURIComponent(initialValues[key])
        )
        .join("&");
      dispatch(initAuthenticationPending());
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}login/access-token`,
          {
            method: "POST",
            body: formBody,
            // mode: 'no-cors',
            headers: new Headers({
              "Content-Type": "application/x-www-form-urlencoded",
              "x-api-key": process.env.REACT_APP_X_API_KEY,
              // withCredentials: false,
            }),
          }
        );
        const res = await response.json();
        if (response?.status === 200 && res?.temp_token) {
          localStorage.setItem("email", email);
          localStorage.setItem("temp_token", res?.temp_token);
          navigate(`/multi-factor-authentication`);
          setLoading(false);
        } else if (
          response?.status === 200 &&
          !res?.temp_token &&
          !!res?.access_token
        ) {
          localStorage.setItem("token", res?.access_token);
          setLoading(false);
          const action = localStorage.getItem("action");
          const plan = localStorage.getItem("plan");
          if (
            (!!action || !!plan) &&
            window.location.href.indexOf("manage-subscriptions") < 0
          ) {
            navigate(
              `/dashboard/manage-subscriptions?action=${action}&plan=${plan}`
            );
          } else navigate(`/dashboard/chatbots`);
        } else if (!res) {
          setLoading(false);
          toast.error("An Error Occurred. Try Again Later");
        } else if (response?.status !== 200) {
          setLoading(false);
          toast.error(res?.detail);
        }
      } catch (error) {
        setLoading(false);
      }
    };
  };

  const navigateToSignUp = () => {
    navigate("/sign-up");
  };
  return (
    <div className="w-screen min-height">
      <Row className="bg-color" style={{ height: "100%" }}>
        <Col lg={12}>
          <div className="mt-3 ml-3">
            <p className="logoname">
              <img
                width={"52%"}
                src="/img/Pansophy-logo.png"
                alt="Pansophy transparent logo"
              />
            </p>
          </div>
          <div className="mx-0 col mb-15">
            <img
              src="/img/pansophy.gif"
              className="mx-auto mt-0 robotimg"
              alt="Pansophy rotating logo"
            />
          </div>
          <div className="space stars1"></div>
          <div className="space stars2"></div>
          <div className="space stars3"></div>
        </Col>
        <Col
          lg={12}
          className="p-4 page-responsiveness"
          style={{ background: "#0C0E0F" }}
        >
          <div className="p-3 page-responsiveness">
            <div className="p-4">
              <h2 className="text-2xl text-white text-md title">Sign In</h2>
              <p className="mb-4 custom-text-light subtitle">
                Welcome to Pansophy, please enter your credentials to login.
              </p>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={SignUpSchema}
              onSubmit={async (values, { resetForm }) => {
                try {
                  await dispatch(login(values.username, values.password));
                } catch (err) {}
              }}
            >
              {({ errors, touched }) => (
                <Form className="w-full">
                  {fields.map((field) => {
                    return (
                      <div className="p-4 pt-3" key={field?.name}>
                        <div className="row">
                          <div className="col-lg-6 col-sm-12">
                            <label
                              htmlFor={field?.name}
                              className="text-sm font-light text-white form-label"
                            >
                              {field?.label}
                            </label>
                          </div>
                          <div className="col-lg-6 col-sm-12">
                            {errors[field?.name] && touched[field?.name] ? (
                              <div className="text-sm text-red-600 align-left">
                                {errors[field?.name]}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <Field
                          type={
                            field?.name === "password" ||
                            field?.name === "confirmPassword"
                              ? "password"
                              : "text"
                          }
                          className="w-full h-12 px-3 text-gray-400 rounded-md input-length input placeholder:text-gray-400 placeholder:text-sm placeholder:font-light focus:outline-none"
                          id={field?.name}
                          name={field?.name}
                          placeholder={field?.placeholder}
                        />
                      </div>
                    );
                  })}
                  <div className="p-4">
                    <div className="row">
                      <div className="col-lg-6 col-sm-12">
                        <button
                          type="button"
                          disabled={loading}
                          className="mt-4 p-2 cancelButton hover:bg-blue-700 text-white w-full mb-2 rounded-md h-14 hover:bg-sky-600/[.8] ease-in duration-200"
                          onClick={navigateToSignUp}
                        >
                          Create an Account
                        </button>
                      </div>
                      <div className="col-lg-6 col-sm-12">
                        <button
                          type="submit"
                          disabled={loading}
                          className={`mt-4 p-2 submitButton hover:bg-blue-700 text-white w-full mb-2 rounded-md h-14 hover:bg-sky-600/[.8] ease-in duration-200 ${
                            loading ? "!italic" : ""
                          }`}
                        >
                          {loading ? "Signing in . . ." : "Sign In"}
                        </button>
                      </div>
                    </div>
                  </div>
                  {!loading && (
                    <div className="pt-5 forgotpwd">
                      <Link to="/forgot-password">
                        {" "}
                        Forgot your Password?{" "}
                        <span className="text-blue-400"> Reset Password</span>
                      </Link>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default SignIn;
